<template>
	<div :class="{ 'hide-marker': editor.mode !== 'editing', 'edit-map': editor.mode === 'editing', 'map-component': true }"
		:style="cssVars">
		<l-map ref="myMap" @ready="doSomethingOnReady()" :zoom.sync="map_params.zoom" :minZoom="10" @update:zoom="refreshClusters()"
			:center.sync="map_params.center" :zoomAnimation="true" @update:bounds="refresh_layer($event)"
			v-on="{ click: info_point ? onMapClick : layer_draw.visible ? addPoint2Polyline : layer_add_poi.visible ? addPoi2Map : empty }"
			:style="{ minHeight: `var(--height)` }" :options="{ zoomControl: false }" :key="map_params.key"
			@click="clickMap">
			<map-lock :propertyAccessorView="propertyAccessorView" @toggleInteraction="toggleInteraction" />

			<l-control-zoom position="topright"
				v-if="editor.mode === 'editing' && !this.active_study.etudeData[this.propertyAccessorView + 'editLock']" />
			<l-control-fullscreen position="bottomright"
				v-if="allow_edit && (this.active_study.etudeType.slug === 'grand_projet' && !(view || linkedToView))"
				:options="{ title: { false: 'Plein écran', true: 'Réduire la carte' } }" />

			<l-control position="topright"
				v-if="editor.mode === 'editing' && !this.active_study.etudeData[this.propertyAccessorView + 'editLock']">
				<notifications-group position="absolute" v-if="map_params.map && map_params.map.isFullscreen()" />
				<div class="leaflet-bar">
					<a @click="undo_map_update" :disabled="!prev_map_params || !prev_map_params.length"
						class="leaflet-bar-part" title="Undo">
						<q-icon name="undo" />
					</a>
				</div>
			</l-control>

			<l-tile-layer :url="urls.mapbox + tokens.mapbox" :attribution="map_params.attribution" />
			<l-geo-json v-if="selected_layer.includes('zonage_urbain')" :geojson="layers.geojson_zonage_urbain"
				:options="info_layers" :options-style="{
					weight: 2,
					color: '#BB0101',
					opacity: 0.5,
					fillOpacity: 0.25,
				}">
			</l-geo-json>
			<l-geo-json v-if="selected_layer.includes('qpv')" :geojson="layers.geojson_qpv" :options="info_layers"
				:options-style="{
					weight: 2,
					color: '#2BA3F1',
					opacity: 1,
					fillOpacity: 0.7,
				}">
			</l-geo-json>
			<l-geo-json v-if="selected_layer.includes('qpv_300')" :geojson="layers.geojson_qpv_300"
				:options="info_layers" :options-style="{
					weight: 2,
					color: '#642EAC',
					opacity: 0.5,
					fillOpacity: 0.25,
				}">
			</l-geo-json>
			<l-geo-json v-if="selected_layer.includes('pnru')" :geojson="layers.geojson_pnru" :options="info_layers"
				:options-style="{
					weight: 2,
					color: '#2BA3F1',
					opacity: 1,
					fillOpacity: 0.7,
				}">
			</l-geo-json>
			<l-geo-json v-if="selected_layer.includes('pnru_300')" :geojson="layers.geojson_pnru_300"
				:options="info_layers" :options-style="{
					weight: 2,
					color: '#642EAC',
					opacity: 0.5,
					fillOpacity: 0.25,
				}">
			</l-geo-json>
			<l-geo-json v-if="selected_layer.includes('npnru')" :geojson="layers.geojson_npnru" :options="info_layers"
				:options-style="{
					weight: 2,
					color: '#2BA3F1',
					opacity: 1,
					fillOpacity: 0.7,
				}">
			</l-geo-json>
			<l-geo-json v-if="selected_layer.includes('npnru_300')" :geojson="layers.geojson_npnru_300"
				:options="info_layers" :options-style="{
					weight: 2,
					color: '#642EAC',
					opacity: 0.5,
					fillOpacity: 0.25,
				}">
			</l-geo-json>
			<l-geo-json v-if="selected_layer.includes('rail')" :geojson="layers.geojson_rail"
				:options-style="styleFunction">
			</l-geo-json>
			<l-geo-json v-if="selected_layer.includes('gpe_lignes')" :geojson="layers.geojson_gpe_lignes"
				:options-style="styleFunction">
			</l-geo-json>
			<l-geo-json v-if="selected_layer.includes('tc_paris')" :geojson="layers.geojson_tc_paris"
				:options-style="styleFunctionParis">
			</l-geo-json>
			<l-geo-json v-if="selected_layer.includes('quartier_adequation')"
				:geojson="layers.geojson_quartier_adequation" :options-style="{
					weight: 2,
					color: '#898989',
					opacity: 0.5,
					fillOpacity: 0.5,
				}">
			</l-geo-json>
			<l-geo-json v-if="selected_layer.includes('commune')" :geojson="layers.geojson_commune" :options-style="{
				weight: 2,
				color: '#898989',
				opacity: 0.5,
				fillOpacity: 0,
			}">
			</l-geo-json>

			<!-- affichage des polylines -->
			<l-marker v-for="(marker, i) in selectedPolygone" :key="`selectedPolygone-marker-${i}`" :lat-lng="marker"
				@click.stop="() => { }" @click.right="removePointFromPolyline(i)" draggable
				@dragend="updateMarkerFromSelectedPolygone($event, i)">
				<l-icon :icon-size="[20, 20]" :icon-anchor="[10, 10]" class-name="current-polygone-marker">
					<div></div>
				</l-icon>
			</l-marker>
			<l-polyline v-if="selectedPolygone && selectedPolygone.length > 1"
				:lat-lngs="[...selectedPolygone, selectedPolygone[0]]" color="#ff8f00"
				:key="`key-polyline-${keyPolyline}`"></l-polyline>

			<l-geo-json
				v-if="active_study && active_study.etudeData && active_study.etudeData.cartographie && active_study.etudeData.cartographie.custom_polygones && active_study.etudeData.cartographie.custom_polygones.ANRU"
				:geojson="active_study.etudeData.cartographie.custom_polygones.ANRU" @click="selectCustomPolygone"
				:options-style="{
					weight: 2,
					color: '#BA2028',
					opacity: 0.5,
					fillOpacity: 0.25
				}" :key="`key-ANRU-${keyPolyline}`" />
			<l-geo-json
				v-if="active_study && active_study.etudeData && active_study.etudeData.cartographie && active_study.etudeData.cartographie.custom_polygones && active_study.etudeData.cartographie.custom_polygones.ZAC"
				:geojson="active_study.etudeData.cartographie.custom_polygones.ZAC" @click="selectCustomPolygone"
				:options-style="{
					weight: 2,
					color: '#1E90FF',
					opacity: 0.5,
					fillOpacity: 0.25
				}" :key="`key-ZAC-${keyPolyline}`" />
			<l-geo-json
				v-if="active_study && active_study.etudeData && active_study.etudeData.cartographie && active_study.etudeData.cartographie.custom_polygones && active_study.etudeData.cartographie.custom_polygones.Centralite"
				:geojson="active_study.etudeData.cartographie.custom_polygones.Centralite" @click="selectCustomPolygone"
				:options-style="{
					weight: 2,
					color: '#F26000',
					opacity: 0.5,
					fillOpacity: 0.25
				}" :key="`key-Centralite-${keyPolyline}`" />
			<l-geo-json
				v-if="active_study && active_study.etudeData && active_study.etudeData.cartographie && active_study.etudeData.cartographie.custom_polygones && active_study.etudeData.cartographie.custom_polygones.Autre"
				:geojson="active_study.etudeData.cartographie.custom_polygones.Autre" @click="selectCustomPolygone"
				:options-style="{
					weight: 2,
					color: '#000000',
					opacity: 0.5,
					fillOpacity: 0.25
				}" :key="`key-Autre-${keyPolyline}`" />
			<l-geo-json
				v-if="active_study && active_study.etudeData && active_study.etudeData.cartographie && active_study.etudeData.cartographie.custom_polygones && active_study.etudeData.cartographie.custom_polygones.Pointille"
				:geojson="active_study.etudeData.cartographie.custom_polygones.Pointille" @click="selectCustomPolygone"
				:options-style="{
					weight: 3,
					color: '#000000',
					opacity: 0.5,
					fillOpacity: 0,
					dashArray: '5, 25',
				}" :key="`key-Pointille-${keyPolyline}`" />

			<l-marker v-if="currentPoi" :lat-lng="currentPoi.coords" @dragend="updateMarkerCurrentPoi" draggable>
				<l-icon :icon-size="[20, 20]" :icon-anchor="[10, 10]" class-name="current-polygone-marker">
					<div></div>
				</l-icon>
			</l-marker>


			<v-marker-cluster v-if="show_ventes && editor.mode=='editing'" key="mutations-cluster" ref="mutations-cluster" :options="{
				maxClusterRadius: 60,
			}">
				<l-geo-json v-for="geoJson in filteredMutations" :key="geoJson.id" :geojson="geoJson"
					:options="mutationsGeoJsonOptions">
				</l-geo-json>
			</v-marker-cluster>


			<l-geo-json v-if="layers.geojson_distance" :geojson="layers.geojson_distance" :options="{}">
			</l-geo-json>
			<v-marker-cluster v-for="cluster in leavesList" :ref="'cluster-' + cluster"
				:key="'cluster-' + cluster + masterKey" :options="{
					name: cluster,
					iconCreateFunction: iconCreate
				}">
				<l-geo-json v-if="!!layers.geojson_point_interet[cluster] == true &&
				layers.geojson_point_interet[cluster].length > 0" :geojson="layers.geojson_point_interet[cluster]" :options="{
		pointToLayer,
		onEachFeature: clickPoi,
	}" :draggable="true">
				</l-geo-json>
			</v-marker-cluster>

			<!-- iconCreateFunction: iconCreateClsPrg, -->
			<map-programs ref="map-programs" @select_marker="select_marker" @select_hardcoded="select_hardcoded"
			@toggleSelectedMutations="toggleSelectedMutations" @update_pos_hard_point="update_pos_hard_point" :linkedToView="linkedToView" :view="view"
			:popup_positions="popup_positions" :selected_markers="selected_markers" :selected_mutations="selected_mutations"
			:programmes="programmes" :hard_coded_programs="hard_coded_programs" :allow_programs="allow_programs" :text_only_program="text_only_program"/>

			<q-spinner-hourglass class="loading" v-if="loading" color="green" size="4em" />
			<q-dialog v-model="alert" color="green">
				<q-card>
					<q-card-section>
						<div class="text-h6">Une erreur a interrompu le traitement</div>
					</q-card-section>

					<q-card-section class="q-pt-none">
						Impossible de continuer le calcul avec les paramètres définis
					</q-card-section>

					<q-card-actions align="right">
						<q-btn flat label="OK" color="green" v-close-popup />
					</q-card-actions>
				</q-card>
			</q-dialog>
			<!-- ICONES  -->
			<l-control position="topleft">
				<div class="wrapperIcone">
					<div class="features-options tooltip" v-if="allow_edit"
						:style="{ top: allow_programs || allow_annotations ? '58px' : undefined }">
						<div class="tooltip-group">
							<div>
								<q-btn class="btn-option btn" text-color="green" icon="my_location"
									@click.stop="reset_center()">
								</q-btn>
							</div>
							<span class="tooltiptext">Centrer sur l'opération</span>
						</div>
					</div>

					<div class="features-options tooltip" v-if="allow_edit && !allow_ventes && !view">
						<div class="tooltip-group">
							<div>
								<q-btn class="btn-option btn" text-color="green" icon="list"
									@click.stop="manage_map_card('filters')">
								</q-btn>
							</div>
							<span class="tooltiptext">Filtrer les données</span>
						</div>
						<q-btn class="btn-direction btn" text-color="green" icon="directions"
							@click.stop="distance_feature.visible = !distance_feature.visible" v-show="false"></q-btn>
						<q-btn class="btn-isochrone btn" text-color="green"
							:icon="info_point ? 'near_me' : 'near_me_disabled'" @click.stop="info_point = !info_point"
							v-show="false"></q-btn>
						<!-- <q-btn class="btn" text-color="green" icon="my_location"></q-btn> -->
					</div>

					<div class="load-programmes tooltip"
						v-if="allow_programs && allow_refresh_programmes && !this.active_study.etudeData[this.propertyAccessorView + 'editLock'] && !view">
						<div class="tooltip-group">
							<div>
								<q-btn class="btn-option btn" text-color="green" icon="maps_home_work"
									@click.stop="load_programmes_reference()">
								</q-btn>
							</div>
							<span class="tooltiptext">Afficher les programmes</span>
						</div>
					</div>

					<div class="features-options tooltip" v-if="allow_edit && allow_ventes && !view">
						<div class="tooltip-group">
							<div>
								<q-btn class="btn-option btn" :color="show_ventes ? 'primary' : undefined"
									:text-color="show_ventes ? 'white' : 'green'" icon="request_quote"
									@click.stop="show_ventes = !show_ventes">
								</q-btn>
							</div>
							<span class="tooltiptext">Afficher les ventes</span>
						</div>
					</div>

					<div class="features-options tooltip" v-if="allow_edit && allow_programs && !view">
						<div class="tooltip-group">
							<div>
								<q-btn class="btn-option btn" text-color="green" icon="legend_toggle"
									@click.stop="manage_map_card('legends')">
								</q-btn>
							</div>
							<span class="tooltiptext">Légendes</span>
						</div>
						<q-btn class="btn-direction btn" text-color="green" icon="directions"
							@click.stop="distance_feature.visible = !distance_feature.visible" v-show="false"></q-btn>
						<q-btn class="btn-isochrone btn" text-color="green"
							:icon="info_point ? 'near_me' : 'near_me_disabled'" @click.stop="info_point = !info_point"
							v-show="false"></q-btn>
						<!-- <q-btn class="btn" text-color="green" icon="my_location"></q-btn> -->
					</div>

					<div class="features-options tooltip" v-if="allow_programs && allow_edit && !view">
						<div class="tooltip-group">
							<div>
								<q-btn class="btn-option btn" text-color="green" icon="add_circle_outline"
									@click.stop="create_hard_coded_operation()">
								</q-btn>
							</div>
							<span class="tooltiptext">Ajouter une opération</span>
						</div>
					</div>

					<div class="features-options tooltip" v-if="allow_ventes && allow_edit && !view">
						<div class="tooltip-group">
							<div>
								<q-btn class="btn-option btn" text-color="green" icon="add_circle_outline"
									@click.stop="create_hard_coded_operation('vente')">
								</q-btn>
							</div>
							<span class="tooltiptext">Ajouter une vente</span>
						</div>
					</div>
					<div class="features-options tooltip" v-if="allow_edit && !view">
						<div class="tooltip-group">
							<div>
								<q-btn class="btn-option btn" text-color="green" icon="layers"
									@click.stop="manage_map_card('options')">
								</q-btn>
							</div>
							<span class="tooltiptext">Selectionner les Points d'intérets</span>
						</div>
						<q-btn class="btn-direction btn" text-color="green" icon="directions"
							@click.stop="distance_feature.visible = !distance_feature.visible" v-show="false"></q-btn>
						<q-btn class="btn-isochrone btn" text-color="green"
							:icon="info_point ? 'near_me' : 'near_me_disabled'" @click.stop="info_point = !info_point"
							v-show="false"></q-btn>
						<!-- <q-btn class="btn" text-color="green" icon="my_location"></q-btn> -->
					</div>

					<div class="features-options tooltip" v-if="allow_edit && view" style="top:180px">
						<div class="tooltip-group">
							<div>
								<q-btn class="btn-option btn" text-color="green" icon="map"
									@click.stop="scrollToBigMap()">
								</q-btn>
							</div>
							<span class="tooltiptext">Modifier la carte</span>
						</div>
					</div>

					<div class="features-options tooltip"
						v-if="allow_edit && (map_params.map.isFullscreen() || linkedToView)" @click.stop="() => { }">
						<div class="tooltip-group">
							<div>
								<q-btn class="btn-option btn" text-color="green" icon="edit_location_alt"
									@click.stop="manage_map_card('add_poi')">
								</q-btn>
							</div>
							<span class="tooltiptext">Ajouter un POI</span>
						</div>
					</div>

					<div class="features-options tooltip"
						v-if="allow_edit && (linkedToView || map_params.map.isFullscreen())" @click.stop="() => { }">
						<div class="tooltip-group">
							<div>
								<q-btn class="btn-option btn" text-color="green" icon="polyline"
									@click.stop="manage_map_card('draw')">
								</q-btn>
							</div>
							<span class="tooltiptext">Dessiner un polygone</span>
						</div>

					</div>

					<div class="features-options tooltip" v-if="allow_edit && allow_annotations && !view">
						<div class="tooltip-group">
							<div>
								<q-btn class="btn-option btn" text-color="green" icon="rate_review"
									@click.stop="create_hard_coded_operation('annotation')">
								</q-btn>
							</div>
							<span class="tooltiptext">Ajouter une annotation</span>
						</div>
					</div>
				</div>
			</l-control>
		</l-map>

		<div class="box-edit-line" v-if="editor.mode === 'editing' && show_ventes">
			<p>Filtrer les ventes</p>
			<div class="q-pa-sm">
				<q-checkbox @input="save_changes()" v-model="filtres_vente.type" val="maison" label="Maison" dense
					class="q-mr-sm" />
				<q-checkbox @input="save_changes()" v-model="filtres_vente.type" val="appartement" label="Appartement"
					dense />
			</div>
			<div class="q-pa-sm">
				<q-select filled v-model="filtres_vente.annee" :options="['Toutes', 2023, 2022, 2021, 2020, 2019]"
					label="Année de transaction" clearable />
			</div>
			<div class="q-pa-md">
				<q-badge color="primary">
					Prix minimum
				</q-badge>
				<q-slider v-model="filtres_vente.prix_min" :min="minPrixMutation" :max="maxPrixMutation" label/>
			</div>
			<div class="q-pa-md">
				<q-badge color="primary">
					Prix maximum
				</q-badge>
				<q-slider v-model="filtres_vente.prix_max" :min="minPrixMutation" :max="maxPrixMutation" label/>
			</div>
			<div class="q-pa-sm">
				<q-btn label="Sélectionner toutes les ventes" @click="selectAllMutations()" />
			</div>
			<div class="q-pa-sm">
				<q-btn label="Désélectionner toutes les ventes" @click="unselectAllMutations()" />
			</div>
		</div>

		<q-slide-transition>
			<q-card v-if="layer_draw.visible" class="my-card q-pa-lg opt-input box-edit-map"
				:class="{ 'allow-full-height': map_params.map.isFullscreen() }">
				<div class="row">
					Type de polygone
					<select v-model="polygoneType" class="full-width">
						<option value="ANRU">ANRU</option>
						<option value="ZAC">ZAC</option>
						<option value="Centralite">Centralité</option>
						<option value="Autre">Autre</option>
						<option value="Pointille">Trait pointillé</option>
					</select>
				</div>
				<div class="row">
					<q-btn dense label="Sauvegarder le polygone dessiné" @click="saveSelectedPolygone" />
				</div>
				<div class="row">
					<q-btn dense label="Supprimer le polygone sélectionné" @click="deleteSelectedCustomPolygon" />
				</div>
			</q-card>
		</q-slide-transition>
		<q-slide-transition>
			<q-card v-if="layer_add_poi.visible" class="my-card q-pa-lg opt-input box-edit-map"
				:class="{ 'allow-full-height': map_params.map.isFullscreen() }">
				<div class="row" v-if="layer_opt">
					Sélectionnez le type du point d'intérêt à ajouter
					<q-tree class="col-12 col-sm-6" :nodes="layer_opt.point_interet" node-key="label"
						tick-strategy="leaf" :ticked.sync="typePoi" color="green" />
				</div>
				<div class="row">
					<div>
						<q-btn :disable=!currentPoi dense label="Ajouter le point d'intérêt" @click="addCustomPoi">
						</q-btn>
					</div>
					<span :class="{ 'disable': currentPoi }" class="tooltiptext btnpoi">Positionner le POI avant de
						l'ajouter</span>
				</div>
			</q-card>
		</q-slide-transition>
		<q-slide-transition>
			<q-card v-if="layer_opt.visible" class="my-card q-pa-lg opt-input box-edit-map slide-transition-select-poi"
				:class="{ 'allow-full-height': map_params.map.isFullscreen() }">
				<q-option-group v-model="selected_layer" :options="layer_opt.optionsinput" color="green"
					type="checkbox" />
				<q-btn label="Points d'intérêt de base" outline no-caps color="green" @click="resetSelectedPoi" />
				<q-tree class="col-12 col-sm-6" :nodes="poiWithoutTransport" node-key="label" tick-strategy="leaf"
					:ticked.sync="ticked" color="green" />
			</q-card>
		</q-slide-transition>
		<q-slide-transition>
			<q-card v-if="layer_leg.visible" class="my-card q-pa-lg fil-input box-edit-map"
				:class="{ 'allow-full-height': map_params.map.isFullscreen() }">
				<table style="width: 100%">
					<tr>
						<td rowspan="2" style="text-align: center; width: 33%">
							Forme Urbaine
						</td>
						<td style="text-align: center; width: 33%">
							<div style="margin: 0 auto" class="legend-icon custom-marker"></div>
						</td>
						<td style="text-align: center; width: 33%">
							<div style="margin: 0 auto" class="legend-icon custom-marker individuel"></div>
						</td>
					</tr>
					<tr>
						<td style="text-align: center">Collectif</td>
						<td style="text-align: center">Individuel</td>
					</tr>
				</table>
			</q-card>
		</q-slide-transition>
		<q-slide-transition>
			<q-card v-if="layer_fil.visible" class="my-card q-pa-lg fil-input box-edit-map"
				:class="{ 'allow-full-height': map_params.map.isFullscreen() }">
				<q-list bordered class="rounded-borders">
					<!-- Forme urbaine -->
					<q-expansion-item v-model="fu_expanded" expand-separator label="Forme urbaine" caption="Filtre"
						@show="hideOtherFilters('fu')">
						<q-card>
							<q-card-section>
								<q-option-group v-model="selected_filter.forme_urbaine"
									:options="layer_fil.optionsfilter.forme_urbaine" color="green" inline />
							</q-card-section>
						</q-card>
					</q-expansion-item>

					<!-- TVA -->
					<q-expansion-item v-model="tva_expanded" expand-separator label="TVA" caption="Filtre"
						@show="hideOtherFilters('tva')">
						<q-card>
							<q-card-section>
								<q-option-group v-model="selected_filter.type_tva"
									:options="layer_fil.optionsfilter.type_tva" color="green" inline />
							</q-card-section>
						</q-card>
					</q-expansion-item>

					<!-- Etat commercialisation -->
					<q-expansion-item v-model="etat_expanded" expand-separator label="Etat Commercialisaton"
						caption="Filtre" @show="hideOtherFilters('etat')">
						<q-card>
							<q-card-section>
								<q-option-group v-model="selected_filter.etat_commercialisation"
									:options="layer_fil.optionsfilter.etat_commercialisation" color="green" inline />
							</q-card-section>
						</q-card>
					</q-expansion-item>
				</q-list>
				<q-btn class="btn-option btn btn-filter" text-color="green" icon="refresh"
					@click.stop="load_programmes_reference()">
					Relancer une recherche
				</q-btn>
			</q-card>
		</q-slide-transition>
		<q-slide-transition>
			<div class="box-edit-line edit_hardcoded"
				v-if="temp_prog && (layer_add_operation.visible || layer_add_annotation.visible || layer_add_vente.visible)">
				<q-form @submit="save_changes()">
					<template v-if="text_only_program">
						<q-input dense v-model="temp_prog.nom" label="Nom du programme" />
					</template>
					<template v-else-if="temp_prog.prog_type === 'annotation'">
						<q-input dense v-model="temp_prog.nom" label="Annotation" />
					</template>
					<template v-else-if="temp_prog.prog_type === 'vente'">
						<p>Edition de la vente</p>
						<q-select v-model="temp_prog.type"
							:options="['T1', 'T2', 'T3', 'T4', 'T5&+', '2P', '3P', '4P', '5P&+']" label="Type" />
						<q-input dense v-model="temp_prog.sbati" label="Surface" />
						<q-input dense v-model="temp_prog.valeurfonc" label="Prix" />
						<q-input dense v-model="temp_prog.anneemut" label="Période de vente" />
					</template>
					<template v-else>
						<p>Edition du programme (hors programmes e-focus)</p>
						<div class="q-pa-sm">
							<q-radio @input="change_forme_urbaine(temp_prog)" v-model="temp_prog.forme_urbaine"
								val="COLLECTIF" label="Collectif" dense class="q-mr-sm" />
							<q-radio @input="change_forme_urbaine(temp_prog)" v-model="temp_prog.forme_urbaine"
								val="INDIVIDUEL" label="Individuel" dense />
						</div>
						<q-input dense v-model="temp_prog.nom" label="Nom du programme" :rules="[ val => val.length > 0 || 'Saisie obligatoire' ]"/>
						<q-input dense v-model="temp_prog.promoteur" label="Promoteur" :rules="[ val => val.length > 0 || 'Saisie obligatoire' ]"/>
						<q-input dense min="0" v-model="temp_prog.stock_initial" label="Stock initial" type="number" :rules="[ val => val.length > 0 || 'Saisie obligatoire']"/>
						<q-input dense min="0" v-model="temp_prog.vente_mois" label="Ventes par mois" type="number" step="0.1" :rules="[ val => val.length > 0 || 'Saisie obligatoire' ]"/>
		
						<template v-if="temp_prog.forme_urbaine == 'COLLECTIF'">
							<q-input min="0" dense v-model="temp_prog.tva_pleine_libre_prix_m2_parking_sans" label="Prix au m² (hors stat.)" type="number" />
							<q-input min="0" dense v-model="temp_prog.tva_pleine_libre_prix_m2_parking_avec" label="Prix au m² (avec stat.)" type="number" />
						</template>
						<template v-else-if="temp_prog.forme_urbaine == 'INDIVIDUEL'">
							<q-input min="0" dense v-model="temp_prog.prix_m2" label="Prix unitaire" type="number" />
						</template>
						<q-input min="0" dense v-model="temp_prog.surface_moyenne" label="SHAB" type="number"/>
						<q-input dense v-model="temp_prog.date_commercialisation" mask="####/##"
							label="MEV (année/mois)" />
						<div v-for="typo in temp_prog.typologies" :key="typo.typologie" >
							<span style="width:10%">{{typo.typologie.toUpperCase()}}</span>
							<q-input min="0" style="width:40%" class="typo-input" dense  v-model="typo.prix_unitaire_moyen" label="PUM" type="number"/>
							<q-input min="0" style="width:25%" class="typo-input" dense v-model="typo.nombre_logement" label="Nb. logs." type="number"/>
							<q-input min="0" style="width:25%" class="typo-input" dense v-model="typo.surface_moyenne" label="SHAB" type="number"/>
						</div>
					</template>
					<div class="hard-coded-button-block">
						<q-btn id="validate-hard-coded-button" type="submit" dense label="Valider" />
						<q-btn id="delete-hard-coded-button" @click="delete_hard_coded_program()" dense label="Supprimer" />
					</div>
				</q-form>
			</div>
		</q-slide-transition>
			<pop-up-wrapper v-if="linkedToView" :selected_mutations="selected_mutations" :selected_programs="selected_programs"
			:selected_markers="selected_markers" :hard_coded_programs="hard_coded_programs" />
		<span v-if="view">Détail des programmes de référence en annexe - cf : carte de localisation</span>
	</div>

</template>

<script>
import PopUpWrapper from "./cartographie/pop-up-wrapper.vue";
import MapLock from "./cartographie/map-lock.vue";
import MapPrograms from "./cartographie/map-programs";

import LControlPolylineMeasure from "vue2-leaflet-polyline-measure";
import LControlFullscreen from "vue2-leaflet-fullscreen";
// import exportFromJSON from 'export-from-json';
import L from "leaflet";
import Vue from "vue";
import { mapGetters } from "vuex";
import _ from "lodash";
import axios from "axios";
import number from "@/libs/number";
import {
	LMap,
	LTileLayer,
	LGeoJson,
	LControl,
	LMarker,
	LIcon,
	LLayerGroup,
	LControlZoom,
	LPolyline
} from "vue2-leaflet";
import Vue2LeafletMarkerCluster from "vue2-leaflet-markercluster";
import { GeojsonStyleHelper } from "../../../../libs/GeojsonStyleHelper.js";

import NotificationsGroup from "../../../global/notifications-group.vue";

import ElementMixin from "@/components/study/editor/elements/element.mixin.js";


Vue.component("l-control-polyline-measure", LControlPolylineMeasure);
Vue.component("l-control-fullscreen", LControlFullscreen);
Vue.component("l-control", LControl);
Vue.component("l-map", LMap);
Vue.component("l-tile-layer", LTileLayer);
Vue.component("l-layer-group", LLayerGroup);
Vue.component("l-geo-json", LGeoJson);
Vue.component("v-marker-cluster", Vue2LeafletMarkerCluster);

Vue.component("l-marker", LMarker);
Vue.component("l-polyline", LPolyline);
Vue.component("l-icon", LIcon);

const DEFAULT_PROGRAM = {
	id: "",
	nom: "",
	promoteur: "",
	prix_m2: "",
	forme_urbaine: "COLLECTIF",
	stat: "false",
	vente_mois: "",
	date_livraison: "",
	url_photo: "",
	stock_initial: "",
	pnru: "",
	tx_ecoulement: "",
	location: {
		lat: "",
		lng: "",
	},
	popup_location: {
		lat: "",
		lng: "",
	},
	date_commercialisation: "",
	typologies: [
		{
			"typologie": "t1",
			"prix_unitaire_moyen": 0,
			"nombre_logement": 0,
			"surface_moyenne": 0
		},
		{
			"typologie": "t2",
			"prix_unitaire_moyen": 0,
			"nombre_logement": 0,
			"surface_moyenne": 0
		},
		{
			"typologie": "t3",
			"prix_unitaire_moyen": 0,
			"nombre_logement": 0,
			"surface_moyenne": 0
		},
		{
			"typologie": "t4",
			"prix_unitaire_moyen": 0,
			"nombre_logement": 0,
			"surface_moyenne": 0
		},
		{
			"typologie": "t5",
			"prix_unitaire_moyen": 0,
			"nombre_logement": 0,
			"surface_moyenne": 0
		},
		{
			"typologie": "t6",
			"prix_unitaire_moyen": 0,
			"nombre_logement": 0,
			"surface_moyenne": 0
		}
	]
};
const DEFAULT_SELECTED_POI = [
	// service
	"Banque",
	// santé-beauté
	"Pharmacie", "Coiffeur", "Médecins",
	// loisirs
	"Tabac - Presse", "Terrain de sport",
	// culture
	"Parc",
	// café - hotel - restaurant
	"Café", "Restaurant",
	// alimentaire
	"Boulangerie", "Epicerie", "Supermarché", "Primeur",
	// equipement public
	"Enseignement", "Université", "Bureau de poste", "Hôtel de ville"
];

export default {
	name: "MapComponent",
	mixins: [ ElementMixin ],
	components: { LMarker, LIcon, LControlZoom, NotificationsGroup, PopUpWrapper, MapLock, MapPrograms },
	data () {
		return {
			temp_prog: undefined,
			map_params: {
				attribution:
					"&copy; <a href=\"https://osm.org/copyright\">OpenStreetMap</a> - <a href=\"https://www.adequation.fr\">Adequation</a> contributors",
				map: "",
				bounds: null,
				map_bbox: null,
				center: [45.7667, 4.83],
				zoom: 15,
				key: 0,
			},
			prev_map_params: false,
			last_prev_map_params: 0,
			undoing_map_params: false,
			tva_expanded: false,
			fu_expanded: false,
			etat_expanded: false,
			selected_layer: [],
			selected_filter: {
				forme_urbaine: "0",
				type_tva: "0",
				etat_commercialisation: "0",
			},
			layer_fil: {
				optionsfilter: {
					forme_urbaine: [
						{
							label: "Collectif (dont Intermédiaire)",
							value: "COLLECTIF",
						},
						{
							label: "Individuel",
							value: "INDIVIDUEL",
						},
						{
							label: "Tous",
							value: "0",
						},
					],
					type_tva: [
						{
							label: "TVA Pleine",
							value: "pleine",
						},
						{
							label: "TVA Réduite",
							value: "reduite",
						},
						{
							label: "Tous",
							value: "0",
						},
					],
					etat_commercialisation: [
						{
							label: "Actif (en cours de commercialisation)",
							value: "actif",
						},
						{
							label: "Terminé",
							value: "termine",
						},
						{
							label: "Tous",
							value: "0",
						},
					],
				},
				visible: false,
			},
			layer_leg: {
				visible: false,
			},
			layer_draw: {
				visible: false
			},
			layer_add_poi: {
				visible: false
			},
			layer_add_operation: {
				visible: false
			},
			layer_add_annotation: {
				visible: false
			},
			layer_add_vente: {
				visible: false
			},
			layer_opt: {
				optionsinput: [
					{
						label: "Zones d'Aménagement Concerté",
						value: "zonage_urbain",
					},
					{
						label: "QPV",
						value: "qpv",
					},
					{
						label: "300m autour des QPV",
						value: "qpv_300",
					},
					{
						label: "PNRU",
						value: "pnru",
					},
					{
						label: "300m autour des PNRU",
						value: "pnru_300",
					},
					{
						label: "NPNRU",
						value: "npnru",
					},
					{
						label: "300m autour des NPNRU",
						value: "npnru_300",
					},
					{
						label: "Transports en commun",
						value: "rail",
					},
					{
						label: "Transports Paris",
						value: "tc_paris",
					},
					{
						label: "Projet transport Grand Paris",
						value: "gpe_lignes",
					},
					{
						label: "Communes",
						value: "commune",
					},
					{
						label: "Quartiers Adequation",
						value: "quartier_adequation",
					},
				],
				point_interet: [
					{
						label: "Points d'intérêts",
						children: [
							{
								label: "Alimentaire",
								disabled: false,
								children: [
									{ label: "Boulangerie" },
									{ label: "Epicerie" },
									{ label: "Supermarché" },
									{ label: "Hypermarché" },
									{ label: "Centre commercial" },
									{ label: "Boucher" },
									{ label: "Primeur" },
								],
							},
							{
								label: "Transport",
								disabled: false,
								children: [
									{ label: "Aeroport" },
									{ label: "Train" },
									{ label: "Bus" },
									{ label: "Metro" },
									{ label: "Tram" },
								],
							},
							{
								label: "Café - Hôtel - Restaurant",
								disabled: false,
								children: [
									{ label: "Hôtel" },
									{ label: "Bar" },
									{ label: "Café" },
									{ label: "Restaurant" },
									{ label: "Camping" },
									{ label: "Camping caravane" },
								],
							},
							{
								label: "Culture",
								disabled: false,
								children: [
									{ label: "Librairie" },
									{ label: "Marchand de journaux" },
									{ label: "Château" },
									{ label: "Musée" },
									{ label: "Parc" },
									{ label: "Théâtre" },
								]
							},
							{
								label: "Loisirs",
								disabled: false,
								children: [
									{ label: "Magasin de jouets" },
									{ label: "Fleuriste" },
									{ label: "Boutique de souvenirs" },
									{ label: "Magasin de sport" },
									{ label: "Papeterie" },
									{ label: "Tabac - Presse" },
									{ label: "Cinéma" },
									{ label: "Terrain de golf" },
									{ label: "Patinoire" },
									{ label: "Terrain de sport" },
									{ label: "Aire de jeux" },
									{ label: "Centre sportif" },
									{ label: "Stade" },
									{ label: "Piscine" },
									{ label: "Parc d'attractions", disabled: true, },
									{ label: "Office du tourisme" },
									{ label: "Zoo" },
								],
							},
							{
								label: "Equipement de la maison",
								disabled: false,
								children: [
									{ label: "Magasin de bricolage" },
									{ label: "Jardinerie" },
									{ label: "Magasin de meubles" },
								],
							},
							{
								label: "Equipement de la personne",
								disabled: false,
								children: [
									{ label: "Magasin de chaussures" },
									{ label: "Bijouterie" },
								],
							},
							{
								label: "Equipement public",
								disabled: false,
								children: [
									{ label: "Police" },
									{ label: "Hôtel de ville" },
									{ label: "Tribunal" },
									{ label: "Bureau de poste" },
									{ label: "Enseignement" },
									{ label: "Université" },
									{ label: "Prison" },
									{ label: "Bâtiment public" },
								],
							},
							{
								label: "Santé - beauté",
								disabled: false,
								children: [
									{ label: "Hôpital" },
									{ label: "Pharmacie" },
									{ label: "Cosmétique" },
									{ label: "Opticien" },
									{ label: "Coiffeur" },
									{ label: "Dentiste" },
									{ label: "Salon de beauté" },
									{ label: "Médecins" },
									{ label: "Maison de repos" },
								],
							},
							{
								label: "Services",
								disabled: false,
								children: [
									{ label: "Vendeur auto" },
									{ label: "Banque" },
									{ label: "Magasin de téléphonie" },
									{ label: "Cimetière" },
									{ label: "Garderie" }
								],
							}
						],
					},
				],
				visible: false,
			},
			alert: false,
			info_point: false,
			distance_feature: {
				model: null,
				visible: false,
				options_label: [
					{ label: "Pied", value: "foot-walking" },
					{ label: "Voiture", value: "driving-car" },
					{ label: "Vélo", value: "cycling-regular" },
					{ label: "Fauteuil roulant", value: "wheelchair" },
				],
			},
			adresses: {
				adr_projet: null,
				adr_dep: null,
				adr_arr: null,
			},
			leavesList: [],
			masterKey: 0,
			clusters: {},
			ticked: [],
			geojsonMarkerOptions: {
				radius: 8,
				fillColor: "#1fb7cb",
				color: "#1fb7cb",
				weight: 0.1,
				opacity: 0.5,
				fillOpacity: 0.5,
			},
			urls: {
				adequation:
					"https://app.myadequation.fr/map/?service=WFS&version=1.0.0&request=GetFeature&typeName=Web:",
				mapbox:
					"https://api.mapbox.com/styles/v1/alexislongsword/ck6qxfwj42hbk1io6m4et74to/tiles/256/{z}/{x}/{y}@2x?access_token=",
			},
			export_format: {
				json_format: "&outputFormat=application/json",
				shapefile_format: "&outputFormat=shape-zip",
			},
			map_bbox: null,
			loading: false,
			layers: {
				geojson_qpv: null,
				geojson_distance: null,
				geojson_quartier_adequation: null,
				geojson_zonage_urbain: null,
				geojson_rail: null,
				geojson_tc_paris: null,
				geojson_gpe_lignes: null,
				geojson_commune: null,
				geojson_qpv_300: null,
				geojson_pnru: null,
				geojson_pnru_300: null,
				geojson_npnru: null,
				geojson_npnru_300: null,
				geojson_point_interet: {},
				geojson_adr_projet: null,
				geojson_mutations: []
			},
			tokens: {
				mapbox:
					"pk.eyJ1IjoiYWxleGlzbG9uZ3N3b3JkIiwiYSI6ImNrMTk2Nmx1MTAxNjMzbnI1dm90em51MjYifQ.xtBAJ0L3V4qVA9CzeXoSAQ",
				open_route_service:
					"5b3ce3597851110001cf62481f147c657b474c02840ea3ac782633c8",
			},
			rawProgrammes: [],
			programmes: [],
			selected_markers: [],
			popup_positions: [],
			hard_coded_programs: [],
			lock: true,
			selected_hard: -1,
			selected_mutations: [],
			show_ventes: false,
			filtres_vente: {
				type: ["maison", "appartement"],
				annee: null,
				prix_max: 0,
				prix_min: 0
			},

			polygoneType: "ANRU",
			selectedPolygone: [],
			selectedPolygoneId: undefined,
			keyPolyline: 0,

			currentPoi: undefined,
			typePoi: ["Boulangerie"]
		};
	},
	props: {
		check_programs: {
			default: false,
			type: Boolean
		},
		default_main_adress: {
			default: undefined,
			type: String,
		},
		default_selected_pois: {
			default: () => [],
			type: Array,
		},
		default_selected_layer: {
			default: () => [],
			type: Array,
		},
		suffix: {
			default: "",
			type: String,
		},
		allow_programs: {
			default: true,
			type: Boolean,
		},
		text_only_program: {
			default: false,
			type: Boolean,
		},
		allow_annotations: {
			default: false,
			type: Boolean
		},
		allow_ventes: {
			default: false,
			type: Boolean
		},
		height: {
			default: 240,
			type: [Number, String]
		},
		view: {
			default: false,
			type: Boolean
		},
		alone: {
			default: false,
			type: Boolean
		},
		linkedToView: {
			default: false,
			type: Boolean
		}
	},
	computed: {
		...mapGetters(["editor", "active_study", "app", "source"]),
		minPrixMutation (){
			let min = 0;
			for(const mutation of this.layers.geojson_mutations){
				if(mutation.properties.valeurfonc < min){
					min = mutation.properties.valeurfonc;
				}
			}
			return min;
		},
		maxPrixMutation (){
			let max = 0;
			for(const mutation of this.layers.geojson_mutations){
				if(mutation.properties.valeurfonc > max){
					max = mutation.properties.valeurfonc;
				}
			}
			return max;
		},
		info_layers () {
			return {
				onEachFeature: this.onEachFeature,
			};
		},
		selected_programs () {
			const programs = [];
			this.selected_markers = this.active_study.etudeData.cartographie["selected_markers" + this.suffix] ? this.active_study.etudeData.cartographie["selected_markers" + this.suffix] : [];
			this.selected_markers.forEach(index => programs.push(this.programmes[index]));
			return programs;
		},
		propertyAccessorView () {
			let value = "";
			if(this.view){
				value = "view_";
			}else if(this.alone){
				value = "alone_";
			}
			return value;
		},
		mutationsGeoJsonOptions () {
			return {
				onEachFeature: (feature, layer) => {
					layer.bindPopup(`
			<div>
              <strong>Nombre de bien(s) :</strong> ${feature.properties.nblocmai + feature.properties.nblocapt}</div>
              <div><strong>Valeur :</strong> ${number.format(feature.properties.valeurfonc, 2)} €</div>
              <div>
                <strong>Nombre de bien(s) :</strong> ${feature.properties.nblocmai + feature.properties.nblocapt}
              </div>
              <div>
                <strong>Surface :</strong> ${number.format(feature.properties.sbati, 0)}m²
              </div>
          `);

					layer.on("mouseover", function () {
						this.openPopup();
					});

					layer.on("mouseout", function () {
						this.closePopup();
					});

					layer.on("click", () => {
						this.toggleSelectedMutations(feature);
					});
				},
				pointToLayer: function (feature, latlng) {
					const svgToDataURL = require("svg-to-dataurl");
					const dataUrl = svgToDataURL(
						require("@/assets/ressources/icons/map_icons/Mutation.svg")
					);
					return L.marker(latlng, {
						icon: L.icon({ iconUrl: dataUrl, iconSize: [32, 32] }),
						draggable: false,
					});
				},
			};
		},
		onEachFeature () {
			return (feature, layer) => {
				layer.bindPopup(
					"<div>Type: " +
					feature.properties.outil_op +
					"</div>" +
					"<div>État: " +
					feature.properties.etat_lib +
					"</div>" +
					"<div>Nom: " +
					feature.properties.nom +
					"</div>" +
					"<div>Commune: " +
					feature.properties.commune1 +
					"</div>" +
					"<div>Maitre d'ouvrage: " +
					feature.properties.mo +
					"</div>" +
					"<div>Aménageur: " +
					feature.properties.amenag +
					"</div>" +
					"<div>Code INSEE: " +
					feature.properties.insee1 +
					"</div>" +
					"<div>Surface [Total]: " +
					feature.properties.sp_tot +
					" m²" +
					"</div>" +
					"<div>Nombre de logements: " +
					feature.properties.nb_logt +
					" m²" +
					"</div>" +
					"<div>Surface [Commerces]: " +
					feature.properties.sp_comm +
					" m²" +
					"</div>" +
					"<div>Surface logements: " +
					feature.properties.sp_logt +
					"</div>" +
					"<div>Surface [Bureaux]: " +
					feature.properties.sp_bur +
					"</div>" +
					"<div>Dates: " +
					"Date 1 :" +
					feature.properties.date1 +
					" Date 2 : " +
					feature.properties.date2 +
					" Date 3 : " +
					feature.properties.date3 +
					"</div>",
					{ closeOnClick: false }
				);
			};
		},
		allow_edit: function () {
			let result;
			try {
				result = this.editor.mode === "editing" && !this.active_study.etudeData[this.propertyAccessorView + "editLock"];
			} catch (error) {
				result = false;
			}
			return result;
		},
		allow_refresh_programmes: function () {
			let result = false;

			if (this.map_params && this.map_params.map) {
				result = this.allow_edit;
			}

			return result;
			// return
		},
		cssVars () {
			return { "--height": `${this.height}px` };
		},
		filteredMutations () {
			return this.layers.geojson_mutations.filter(mutation => {
				let selected = true;

				if (
					!this.filtres_vente.type.some(type => {
						return mutation.properties.libtypbien.toLowerCase().includes(type);
					})
				) {
					selected = false;
				}

				if (this.filtres_vente.annee && mutation.properties.anneemut !== this.filtres_vente.annee) {
					selected = false;
				}

				if(this.filtres_vente.prix_max < mutation.properties.valeurfonc || this.filtres_vente.prix_min > mutation.properties.valeurfonc){
					selected = false;
				}
				return selected;
			});
		},
		poiWithoutTransport () {
			function searchAndDestroy (node, labelToDestroy) {
				// search recursively in the tree and destroy the element based on it's label value
				if (node.label.toLowerCase() === labelToDestroy.toLowerCase()) return null;
				if(typeof node.children !== "undefined"){
					const newChildren = [];
					for (const i in node.children) {
						const newChild = searchAndDestroy(node.children[i], labelToDestroy);
						if (newChild)
							newChildren.push(newChild);
					}
					node.children = newChildren;
				}
				return node;
			}
			const layer = _.cloneDeep(this.layer_opt);
			searchAndDestroy(layer.point_interet[0] , "transport");
			return layer.point_interet;
		}
	},
	watch: {
		"editor.mode": function (){
			this.refresh_center();
		},
		minPrixMutation: function (newValue){
			if(this.filtres_vente.prix_min === 0 && newValue !== 0){
				this.filtres_vente.prix_min = newValue;
			}
		},
		maxPrixMutation: function (newValue){
			if(this.filtres_vente.prix_max === 0 && newValue !== 0){
				this.filtres_vente.prix_max = newValue;
			}
		},
		selected_layer: function (new_value) {
			this.refresh_layer();
			// this.$emit('select_layer', this.selected_layer);
			this.$store.commit("SET_CARTOGRAPHIE", {
				index: "selected_layer" + this.suffix,
				value: new_value,
			});
			this.$store.dispatch("save_study");
		},
		ticked: function (new_value) {
			// this.$emit('select_poi', new_value);
			this.$store.commit("SET_CARTOGRAPHIE", {
				index: "poi" + this.suffix,
				value: new_value,
			});
			this.$store.dispatch("save_study");
			this.load_point_interet();
			// this.$forceUpdate();
		},
		popup_positions: function (new_value) {
			this.$store.commit("SET_CARTOGRAPHIE", {
				index: "popups" + this.suffix,
				value: new_value,
			});
			this.$store.dispatch("save_study");
		},
		hard_coded_programs: function (new_value) {
			this.$store.commit("SET_CARTOGRAPHIE", {
				index: "hard_coded_programs" + this.suffix,
				value: [...new_value],
			});
			this.$store.dispatch("save_study");
		},
		selected_markers: function (new_value) {
			if (this.lock) return;
			try {
				const temp = [];
				const temp_p = [];
				new_value.forEach((n) => {
					if(this.programmes[n]){
						temp.push(this.programmes[n].id);

						const pop = this.popup_positions.find((p) => {
							return p.id === this.programmes[n].id;
						});
						if (pop) {
							temp_p.push(pop);
						} else {
							temp_p.push({
								id: this.programmes[n].id,
								lat: this.programmes[n].location.lat,
								lng: this.programmes[n].location.lon,
							});
						}
					}
				});

				this.popup_positions = temp_p;
				const data = {
					"programmes": temp
				};
				this.$store.dispatch("get_donnees_reference_programmes", data);
				this.$store.dispatch("save_study");
			} catch (e) {
				console.error(e);
			}
		},
		selected_filter: {
			handler (n) {
				if (typeof (n) !== "undefined") {
					this.save_filters();
					this.filter_programmes();
					this.check_selected();
				}
			},
			deep: true,
		},
		"map_params.zoom": {
			handler (_new, old) {
				if (old && !this.undoing_map_params) {
					this.pushOldMapParam({
						zoom: old,
					});
				}
			},
		},
		"map_params.center": {
			handler (_new, old) {
				if (old && !this.undoing_map_params) {
					this.pushOldMapParam({
						center: old,
					});
				}
			},
		},
		"layer_fil.visible" (visible) {
			if (visible) {
				this.$refs.myMap.mapObject.scrollWheelZoom.disable();
			} else {
				this.$refs.myMap.mapObject.scrollWheelZoom.enable();

			}
			// this.$refs.myMap.options.scrollWheelZoom = !newValue
		},
		show_ventes (toggle) {
			if (toggle) {
				this.load_layer(this.export_format.json_format, "mutations", 500, true);
				// this.selected_layer.push('mutations')
			} else {
				this.selected_layer = this.selected_layer.filter(e => e !== "mutations");
			}
		},

		typePoi: function (newSelection) {
			if (newSelection.length > 1) {
				this.typePoi = newSelection.splice(-1, 1);
			}
		}
	},
	methods: {
		clickPoi (feature, layer) {
			layer.on("click", () => {
				const gid = feature.properties.gid;
				const hidden_poi = [...this.active_study.etudeData.cartographie["hidden_poi"]];
				if(hidden_poi.includes(gid)){
					hidden_poi.splice(hidden_poi.indexOf(gid), 1);
				}else{
					hidden_poi.push(gid);
				}
				this.$store.commit("SET_CARTOGRAPHIE", {
					index: "hidden_poi",
					value: hidden_poi,
				});
				this.refresh_center();
			});
		},
		selectAllMutations (){
			for(let mutation of this.filteredMutations){
				const index = this.selected_mutations.findIndex((tmpMutation) => tmpMutation.id === mutation.id);

				if (index !== -1) {
					this.selected_mutations[index] = mutation;
				} else if (index === -1) {
					mutation = {
						...mutation,
						popup_position: [mutation.geometry.coordinates[1], mutation.geometry.coordinates[0]],
						pin_position: [mutation.geometry.coordinates[1], mutation.geometry.coordinates[0]]
					};

					this.selected_mutations = [...this.selected_mutations, mutation];
				}
			}
			this.$store.commit("SET_CARTOGRAPHIE", {
				index: "selected_mutations" + this.suffix,
				value: this.selected_mutations,
			});
			this.$store.dispatch("save_study");
		},
		unselectAllMutations (){
			this.selected_mutations = [];
			this.$store.commit("SET_CARTOGRAPHIE", {
				index: "selected_mutations" + this.suffix,
				value: this.selected_mutations,
			});
			this.$store.dispatch("save_study");
		},
		scrollToBigMap () {
			this.$root.$emit("scrollToBigMap" + this.active_study.segment.code);
		},
		check_selected () {
			const self = this;
			const selected_markers_ToSave = _.cloneDeep(self.selected_markers);

			// 1/2 - feed selected_markers_ToSave from self.selected_markers & prg.display
			self.selected_markers.forEach(marker => {
				const prg = self.programmes[marker];
				if (prg.display === false) {
					selected_markers_ToSave.splice(selected_markers_ToSave.indexOf(marker), 1);
				}
			});

			// 2/2 Save new state of selected_markers
			self.selected_markers = selected_markers_ToSave;
			this.$store.commit("SET_CARTOGRAPHIE", {
				index: "selected_markers" + this.suffix,
				value: selected_markers_ToSave,
			});
			this.$store.dispatch("save_study");
		},
		filter_programmes () {
			const self = this;
			const programmesToSave = _.cloneDeep(self.programmes);
			const filterToApply = self.selected_filter;

			// init display all
			programmesToSave.forEach(
				(prg) =>
					prg.display = true
			);

			// * FILTER -  FORME URBAINE *
			if (filterToApply.forme_urbaine !== "0") {
				programmesToSave.forEach(
					function (prg) {
						if (prg.forme_urbaine !== filterToApply.forme_urbaine) {
							//JNA :  if filter.FU = 'collectif' => display prg.FU  in ('collectif,'intermediaire')
							if (!(prg.forme_urbaine.toUpperCase() === "INTERMEDIAIRE" && filterToApply.forme_urbaine.toUpperCase() === "COLLECTIF")) {
								prg.display = false;
							}
						}
					}
				);
			}

			// * FILTER -  TVA PLEINE & REDUITE *
			if (filterToApply.type_tva === "pleine") {
				programmesToSave.forEach(
					function (prg) {
						if (prg.filter_tva_pleine !== true) {
							prg.display = false;
						}
					}
				);
			} else if (filterToApply.type_tva === "reduite") {
				programmesToSave.forEach(
					function (prg) {
						if (prg.filter_tva_reduite !== true) {
							prg.display = false;
						}
					}
				);
			}


			// * FILTER -  ETAT ACTIF/TERMINE *
			if (filterToApply.etat_commercialisation === "termine") {
				programmesToSave.forEach(
					function (prg) {
						if (prg.filter_etat_commercialisation_termine !== true) {
							prg.display = false;
						}
					}
				);
			} else if (filterToApply.etat_commercialisation === "actif") {
				programmesToSave.forEach(
					function (prg) {
						if (prg.filter_etat_commercialisation_termine === true) {
							prg.display = false;
						}
					}
				);
			}

			self.programmes = programmesToSave;
			// Save PROGRAMMES
			self.$store.commit("SET_CARTOGRAPHIE", {
				index: "programmes",
				value: programmesToSave,
			});
			self.$store.dispatch("save_study");

			//reprint map
			this.reprint();
		},
		checkPrograms () {
			if (this.active_study.etudeData.cartographie.saved_payload) {
				const config = {
					method: "post",
					url: `${process.env.VUE_APP_API_BASE_URL}api/efocus/api/GetProgrammes`,
					data: this.active_study.etudeData.cartographie.saved_payload,
					cancelToken: this.source.token
				};
				axios(config).then((r) => {
					const prog = r.data.content;
					const saved_programs = [...this.active_study.etudeData.cartographie.programmes];
					for (const element in saved_programs) {
						delete saved_programs[element]["display"];
					}
					if (typeof this.active_study.etudeData.cartographie != "undefined" && typeof this.active_study.etudeData.cartographie.programmes != "undefined" && this.active_study.etudeData.cartographie.programmes != {}) {
						if (JSON.stringify(prog) != JSON.stringify(saved_programs)) {
							if (confirm("Des modifications sur les données des programmes ont été réalisées depuis la dernière consultation de cette étude. Voulez-vous rafraichir les programmes référents de votre étude ?")) {
								this.$store.commit("SET_CARTOGRAPHIE", {
									index: "programmes",
									value: prog,
								});
								this.selected_markers = [];
								this.$store.commit("SET_CARTOGRAPHIE", {
									index: "selected_markers",
									value: [],
								});
								this.$store.dispatch("save_study");
								this.$root.$emit("updateRawPrograms");
							}
						}

					}
				}).catch((e) => {
					if(e !== "cancelled"){
						console.error(e);
					}
				});
			}
		},
		toggleInteraction (value) {
			this.$refs.myMap.mapObject._handlers.forEach(function (handler) {
				if (value) handler.disable();
				else handler.enable();
			});
		},
		pushOldMapParam (oldParam) {
			if (Date.now() - this.last_prev_map_params > 2000) {
				if (this.prev_map_params === false) {
					this.prev_map_params = [];
				} else {
					this.prev_map_params.push(oldParam);
				}

				this.last_prev_map_params = Date.now();
			}
		},
		manage_map_card: function (layer) {
			this.layer_fil.visible = layer === "filters" ? !this.layer_fil.visible : false;
			this.layer_opt.visible = layer === "options" ? !this.layer_opt.visible : false;
			this.layer_leg.visible = layer === "legends" ? !this.layer_leg.visible : false;
			this.layer_draw.visible = layer === "draw" ? !this.layer_draw.visible : false;
			this.layer_add_poi.visible = layer === "add_poi" ? !this.layer_add_poi.visible : false;
			this.layer_add_operation.visible = layer === "add_operation";
			this.layer_add_annotation.visible = layer === "add_annotation";
			this.layer_add_vente.visible = layer === "add_vente";


			// pour retirer les marqueurs utilisés pour dessiner un polygone de la carte
			if (this.layer_draw.visible === false) {
				this.selectedPolygone = [];
				this.selectedPolygoneId = undefined;
				this.polygoneType = "ANRU";
				this.keyPolyline++;
			}
			// pour retirer le marqueur de création de POI
			if (this.layer_add_poi.visible === false) {
				this.currentPoi = undefined;
			}
		},
		hideOtherFilters: function (filter) {
			if (filter === "fu") {
				this.tva_expanded = false;
				this.etat_expanded = false;
			} else if (filter === "tva") {
				this.fu_expanded = false;
				this.etat_expanded = false;
			} else if (filter === "etat") {
				this.fu_expanded = false;
				this.tva_expanded = false;
			}
		},
		select_marker: function (i) {
			const temp = [...this.selected_markers];
			if (temp.indexOf(i) > -1) {
				temp.splice(temp.indexOf(i), 1);
			} else {
				temp.push(i);
			}

			if (temp.length + this.hard_coded_programs.filter((hc) => hc.prog_type === "prog").length <= 6) {
				this.selected_markers = [...temp];
				this.$store.commit("SET_CARTOGRAPHIE", {
					index: "selected_markers" + this.suffix,
					value: [...temp],
				});
				this.$store.dispatch("save_study");
			}
		},
		styleFunctionParis (feature) {
			return this.styleFunction(feature, true);
		},
		styleFunction (feature, paris = false) {
			const style = new GeojsonStyleHelper(feature.properties);
			if (style.color === GeojsonStyleHelper.defaultStyle.color) {
				switch (feature.properties.fclass) {
					case 'tram':
						style.color = '#D3A516';
						break;
					case 'subway':
						if(paris){
				  			style.color = "#" + feature.properties.colourweb_h;
						}else{
							style.color = '#44B281';
						}
						break;
					case 'ter':
						style.color = '#C6156A';
						break;
					case 'rer':
						style.color = '#10ACC1';
						break;
					case 'train':
						style.color = '#932A74';
						break;
					default:
						style.weight = 0;
				}
			}
			if (GeojsonStyleHelper.regexpShouldBeDashArray(feature.id) ) style.dashArray = GeojsonStyleHelper.dashArrayStyle;

			return style;
		},
		onMapClick (e) {
			const popup = L.popup();
			popup
				.setLatLng(e.latlng)
				.setContent(
					"<b>" + "Latitude , Longitude" + "</b>" + "<br/>" + e.latlng
				)
				.openOn(this.map_params.map);
		},
		empty () {
			//do nothing
		},
		load_adresse (layer){
			const geometry = {
				"coordinates": [this.active_study.projet.position.location.lon,this.active_study.projet.position.location.lat],"type": "Point"
			};
			const nom = this.active_study.etudeData.titre;
			const feature = [{geometry,"type": "Feature"}];
			this.layers["geojson_" + layer] = feature;
			const project = L.geoJSON(this.layers["geojson_" + layer], {
				onEachFeature: function (feature, layer) {
					layer.bindPopup("<b> Nom : </b>" + nom);
				},
				pointToLayer: function (feature, latlng) {
					const svgToDataURL = require("svg-to-dataurl");
					const dataUrl = svgToDataURL(
						require("@/assets/ressources/icons/map_icons/" +
									"projet" +
									".svg")
					);
					return L.marker(latlng, {
						icon: L.icon({ iconUrl: dataUrl, iconSize: [40, 40], className: "project" }),
						draggable: false,
					});
				},
			});
			project.addTo(this.map_params.map);
		},
		pointToLayer (feature, latlng) {
			const that = this;
			let iconUrl;
			let dataUrl;
			try {
				const svgToDataURL = require("svg-to-dataurl");
				dataUrl = svgToDataURL(
					require("@/assets/ressources/icons/map_icons/" +
						feature.properties.fclass_fr +
						".svg")
				);
				iconUrl = dataUrl;
				// iconUrl = require('@/assets/ressources/icons/map_icons/' + feature.properties.fclass_fr + '.svg')
			} catch (e) {
				const svgToDataURL = require("svg-to-dataurl");
				dataUrl = svgToDataURL(
					require("@/assets/ressources/icons/map_icons/default.svg")
				);
				iconUrl = dataUrl;
			}
			if (feature && feature.properties.customPoi) {
				const marker = L.marker(latlng, {
					icon: new L.DivIcon({
						html: "<div class='custom-poi-parent'><div style='position: relative;'><img alt='poi' class='icon-img-custom-poi' src=\"" + iconUrl + "\"/><div class='icon-close-custom-poi'>x</div></div>",
						className: "poi-marker",
						iconSize: [30, 30],
					}),
				});

				marker.draggable = false; // set to true does not work
				marker.on("click", function (e) {
					that.removeCustomPoi(e.sourceTarget.feature.geometry.coordinates);
				});
				return marker;
			}
			else if (iconUrl) {
				const hidden_poi = this.active_study.etudeData.cartographie["hidden_poi"];
				const poiVisibilityClass = hidden_poi.includes(feature.properties.gid) ? this.editor.mode === "editing" ? "poi-unselected" : "poi-hidden" : "poi-selected";
				return L.marker(latlng, {
					icon: L.icon({
						iconUrl: iconUrl,
						iconSize: [30, 30],
						className: `poi-marker ${poiVisibilityClass}`
					}),
				});
			} else {
				return L.circleMarker(latlng, this.geojsonMarkerOptions);
			}
		},
		refreshClusters (){
			const mapPrograms = this.$refs["map-programs"];
			if(mapPrograms){
				if (mapPrograms.$refs["cluster_prg"]) {
					mapPrograms.$refs["cluster_prg"].mapObject.refreshClusters();
				}
				if (mapPrograms.$refs["selected-mutations-cluster"]) {
					mapPrograms.$refs["selected-mutations-cluster"].mapObject.refreshClusters();
				}
			}
		},
		clickMap () {
			//this.$refs["cluster_prg"].mapObject._refreshClustersIcons();
			this.refreshClusters();
		},
		iconCreate (marker_cluster) {
			const childCount = marker_cluster.getAllChildMarkers().filter((marker) => {
				const classNames = marker.options.icon.options.className;
				return !classNames.includes("poi-hidden") && !classNames.includes("poi-unselected");
			}).length;
			const getFirstMarker = function (cluster) {
				if (cluster._markers.length > 0) {
					return cluster._markers[0];
				}
				return getFirstMarker(cluster._childClusters[0]);
			};

			let icon;
			const svgToDataURL = require("svg-to-dataurl");
			try {
				const marker = getFirstMarker(marker_cluster);
				icon = marker.options.icon.options.iconUrl;
				if (typeof icon === "undefined") {
					const stringMarker = marker.options.icon.options.html;
					if (typeof stringMarker !== "undefined") {
						const htmlMarker = new DOMParser().parseFromString(stringMarker, "text/html");
						icon = htmlMarker.firstChild.getElementsByTagName("img")[0].src;
					}
					else {
						throw new Error("Icon not found");
					}
				}
			} catch (e) {
				if (e.message !== "Icon not found") {
					console.error(e);
				}
				icon = svgToDataURL(require("@/assets/ressources/icons/map_icons/default.svg"));
			}
			// show 1 only in edit mode to be able to determine unselected marker inside cluster
			const countTag = childCount > 1 || this.editor.mode == "editing" ? `<div class='icon-total-childs'>${childCount}</div>` : "";
			const poiVisibilityClass = childCount == 0 ? this.editor.mode === "editing" ? "poi-unselected" : "poi-hidden" : "poi-selected";
			return new L.DivIcon({
				html: `<div style='position: relative;'><img alt='cluster' class='icon-cluster' src="${icon}"/>${countTag}</div>`,
				className: `poi-marker-cluster ${poiVisibilityClass}`,
				iconSize: [30, 30],
			});
		},
		toggleSelectedMutations (mutation, forceUpdate = false) {
			const index = this.selected_mutations.findIndex((tmpMutation) => tmpMutation.id === mutation.id);

			if (forceUpdate && index !== -1) {
				this.selected_mutations[index] = mutation;
			} else if (index === -1) {
				mutation = {
					...mutation,
					popup_position: [mutation.geometry.coordinates[1], mutation.geometry.coordinates[0]],
					pin_position: [mutation.geometry.coordinates[1], mutation.geometry.coordinates[0]]
				};

				this.selected_mutations = [...this.selected_mutations, mutation];
			} else {
				this.selected_mutations = this.selected_mutations.filter(tmpMutation => tmpMutation.id !== mutation.id);
			}

			this.$store.commit("SET_CARTOGRAPHIE", {
				index: "selected_mutations" + this.suffix,
				value: this.selected_mutations,
			});
			this.$store.dispatch("save_study");
		},
		doSomethingOnReady () {
			this.map_params.map = this.$refs.myMap.mapObject;
			if (!!this.active_study.etudeData.cartographie[this.propertyAccessorView + "map_center"] && !!this.active_study.etudeData.cartographie[this.propertyAccessorView + "map_center"].lat) {
				this.refresh_center();
			} else {
				this.reset_center();
			}
			if (this.check_programs) {
				this.checkPrograms();
			}
		},
		load_layer (format, layer, nbr_items = 500, force = false) {
			if (this.selected_layer.includes(layer) || force) {
				this.loading = true;
				this.map_bbox = this.map_params.map.getBounds().toBBoxString();
				const config = {
					method: "get",
					url:
						this.urls.adequation +
						layer +
						"&maxFeatures=" +
						nbr_items +
						"&cql_filter=BBOX(geom," +
						this.map_bbox +
						")" +
						format,
					cancelToken: this.source.token
				};
				axios(config)
					.then((response) => {
						this.layers["geojson_" + layer] = response.data.features;
						this.layers = { ...this.layers };
						this.loading = false;
					})
					.catch(function (error) {
						if(error !== "cancelled") {
							console.error(error);
						}
					});
			}
		},
		load_point_interet () {
			this.loading = true;
			if(this.ticked.length > 0) {
				// if there are POI to search, we do the API call
				this.map_bbox = this.map_params.map.getBounds().toBBoxString();
				const config = {
					method: "get",
					url:
                      this.urls.adequation +
                      "vue_poi&maxFeatures=500&cql_filter=BBOX(wkb_geometry," +
                      this.map_bbox +
                      ") AND fclass_fr in ('" +
                      this.ticked.join("','") +
                      "'" +
                      ")" +
                      this.export_format.json_format,
					cancelToken: this.source.token
				};
				axios(config)
					.then((response) => {
						this.reload_clusters(response);
						this.masterKey++;
						this.loading = false;
					})
					.catch((error) => {
						if(error !== "cancelled"){
							console.error(error);
						}
						this.loading = false;
					});
			}else{
				// if there is nothing to search, we reload with an empty response instead of doing the API call
				this.reload_clusters(
					{
						"data": {
							"type": "FeatureCollection",
							"features": [],
							"totalFeatures": 0,
							"numberMatched": 0,
							"numberReturned": 0,
						}
					}
				);
				this.masterKey++;
				this.loading = false;
			}

		},
		reload_clusters (response){
			let customPOI = [];
			if (!!this.active_study.etudeData.cartographie[`custom_poi${this.suffix}`] && this.active_study.etudeData.cartographie[`custom_poi${this.suffix}`].length > 0) {
				customPOI = this.active_study.etudeData.cartographie[`custom_poi${this.suffix}`].filter((p) => p != null) || [];
			}
			this.leavesList.forEach((cluster) => {
				this.layers.geojson_point_interet[cluster] = [...response.data.features.filter((feature) => { return feature.properties.fclass_fr === cluster; }), ...customPOI.filter((p) => p.type === cluster).map((p) => {
					return {
						"type": "Feature",
						"geometry": {
							"type": "Point",
							"coordinates": [p.coords[1], p.coords[0]]
						},
						"geometry_name": "wkb_geometry",
						"properties": {
							"fclass_fr": cluster,
							"customPoi": true
						},
					};
				})];
				try {
					try{
						this.$refs["cluster-" + cluster][0].mapObject.refreshClusters();
					}
					catch{
						this.$refs["map-programs"].$refs["cluster-" + cluster][0].mapObject.refreshClusters();
					}
				} catch (e) {
					console.error(e);
				}
			});
		},
		load_programmes_reference () {
			let reload = true;
			if(this.selected_markers.length !== 0 ){
				reload = confirm("Si vous effectuez une nouvelle recherche, vos programmes seront désélectionnés.\nSouhaitez vous faire une nouvelle recherche ?");
			}
			if(reload) {
				this.programmes = [];
				this.$store.commit("SET_CARTOGRAPHIE", {
					index: "selected_markers" + this.suffix,
					value: [],
				});
				const bounds = this.map_params.map.getBounds();
				const projectLocationLat = this.active_study.projet.position.location.lat;
				const projectLocationLon = this.active_study.projet.position.location.lon;

				if (this.lock) return;

				const self = this;
				const programmes_limit = 100;
				const payload = {
					hd_lat: bounds._northEast.lat,
					hd_lon: bounds._northEast.lng,
					bg_lat: bounds._southWest.lat,
					bg_lon: bounds._southWest.lng,
					size: programmes_limit,
					project_lat: projectLocationLat,
					project_lon: projectLocationLon
				};
				this.$store.commit("SET_CARTOGRAPHIE", {
					index: "saved_payload",
					value: payload,
				});
				this.loading = true;
				const config = {
					method: "post",
					url: `${process.env.VUE_APP_API_BASE_URL}api/efocus/api/GetProgrammes`,
					data: payload,
					cancelToken: this.source.token
				};
				axios(config)
					.then(function (r) {
						if (r.data.content.length >= programmes_limit) {
							self.$store.dispatch("add_notification", {
								status: "info",
								message: "Seul les 100 premiers programmes trouvés dans cette zone sont affichés. Zoomez davantage pour plus de précision.",
							});
						}
						if (r.data.content.length < 10 && self.map_params.map.getZoom() > 13) {
							self.map_params.map.zoomOut();
							self.load_programmes_reference();
							return;
						}
						self.rawProgrammes = r.data.content;
						self.programmes = self.rawProgrammes;
						self.programmes.forEach(
							(prg) =>
								prg.display = true
						);
						self.$store.commit("SET_CARTOGRAPHIE", {
							index: "programmes",
							value: self.programmes,
						});
						self.$store.dispatch("save_study");
						self.filter_programmes();
						self.loading = false;
					})
					.catch(function (e) {
						if(e !== "cancelled"){
							console.error(e);
						}
					});
			}
		},
		save_filters () {
			const filters = _.cloneDeep(this.selected_filter);
			this.$store.commit("SET_CARTOGRAPHIE",
				{
					index: "filters",
					value: filters,
				}
			);
			this.$store.dispatch("save_study");
		},
		refresh_layer (event = undefined) {
			this.refreshClusters();

			this.load_layer(this.export_format.json_format, "zonage_urbain", 4000);
			this.load_layer(this.export_format.json_format, "rail", 10000);
			this.load_layer(this.export_format.json_format, "tc_paris", 10000);
			this.load_layer(this.export_format.json_format, "gpe_lignes", 10000);
			this.load_layer(this.export_format.json_format, "quartier_adequation");
			this.load_layer(this.export_format.json_format, "qpv");
			this.load_layer(this.export_format.json_format, "qpv_300");
			this.load_layer(this.export_format.json_format, "pnru");
			this.load_layer(this.export_format.json_format, "pnru_300");
			this.load_layer(this.export_format.json_format, "npnru");
			this.load_layer(this.export_format.json_format, "npnru_300");
			this.load_layer(this.export_format.json_format, "commune");
			this.load_point_interet();
			// this.load_programmes_reference();

			if (this.show_ventes) {
				this.load_layer(this.export_format.json_format, "mutations", 500, true);
			}

			this.rawProgrammes = this.programmes = [...this.programmes];

			const bounds = this.map_params.map.getBounds();
			const formatted_bounds = [
				[bounds._northEast.lat, bounds._northEast.lng],
				[bounds._southWest.lat, bounds._southWest.lng],
			];

			if (event && this.allow_edit) {
				this.$store.commit("SET_CARTOGRAPHIE", {
					index: this.propertyAccessorView + "bbox" + this.suffix,
					value: formatted_bounds,
				});

				this.$store.commit("SET_CARTOGRAPHIE", {
					index: this.propertyAccessorView + "map_center" + this.suffix,
					value: this.map_params.map.getCenter(),
				});

				this.$store.commit("SET_CARTOGRAPHIE", {
					index: this.propertyAccessorView + "map_zoom" + this.suffix,
					value: this.map_params.map.getZoom(),
				});
				this.$store.dispatch("save_study");
			}
		},
		update_pos: function (e, i) {
			if (  !this.popup_positions.some((p) => {
					return p.id === i;
				})
			)
				return;

			let t = this.popup_positions.find((p) => {
				return p.id === i;
			});
			t = JSON.parse(JSON.stringify(t));
			t.lat = e.lat;
			t.lng = e.lng;

			for (let i = 0; i < this.popup_positions.length; i++) {
				if (this.popup_positions[i].id === t.id) this.popup_positions[i] = t;
			}
			this.popup_positions = [...this.popup_positions];
		},
		update_pos_hard_point: function (e, i, type) {
			const temp = JSON.parse(
				JSON.stringify(this.hard_coded_programs[i][type])
			);

			temp.lat = e.lat;
			temp.lng = e.lng;

			const add = {};
			add[type] = temp;

			this.hard_coded_programs[i] = { ...this.hard_coded_programs[i], ...add };

			this.hard_coded_programs = [...this.hard_coded_programs];
		},
		select_hardcoded: function (val) {
			this.selected_hard = val;
			this.temp_prog = _.cloneDeep(this.hard_coded_programs[val]);
			if (this.temp_prog.prog_type === "prog") {
				this.manage_map_card("add_operation");
			} else {
				this.manage_map_card("add_annotation");
			}
		},
		update_hardcoded: function (e, i, element) {
			const temp = JSON.parse(JSON.stringify(this.hard_coded_programs[i]));
			temp[element] = e.value;

			this.hard_coded_programs[i] = [...temp];

			this.hard_coded_programs = [...this.hard_coded_programs];
		},
		reset_center: function () {
			this.map_params.map.panTo(
				new L.LatLng(
					this.active_study.projet.position.location.lat,
					this.active_study.projet.position.location.lon
				)
			);
		},
		refresh_center: function () {
			//this.map_params.map.setZoom(this.active_study.etudeData.cartographie.map_zoom);
			if(this.active_study.etudeData.cartographie[this.propertyAccessorView + "map_center"] == undefined){
				return;
			}
			this.map_params.map.panTo(
				new L.LatLng(
					this.active_study.etudeData.cartographie[this.propertyAccessorView + "map_center"].lat,
					this.active_study.etudeData.cartographie[this.propertyAccessorView + "map_center"].lng

				)
			);
		},
		reprint: function () {
			if (this.map_params.map) {
				this.map_params.map.panTo(
					new L.LatLng(
						this.map_params.map.getCenter().lat,
						this.map_params.map.getCenter().lng
					)
				);
			}
		},
		delete_hard_coded_program: function () {
			this.hard_coded_programs.splice(this.selected_hard, 1);
			this.hard_coded_programs = [...this.hard_coded_programs];
			this.temp_prog = undefined;
			this.selected_hard = -1;
		},
		change_forme_urbaine: function (prog) {
			delete prog.prix_m2;
			delete prog.tva_pleine_libre_prix_m2_parking_avec;
			delete prog.tva_pleine_libre_prix_m2_parking_sans;

			prog.stat = prog.forme_urbaine === "INDIVIDUEL" ? "true" : "false";
		},
		save_changes: function () {
			this.hard_coded_programs[this.selected_hard] = _.cloneDeep(this.temp_prog);
			this.hard_coded_programs = [...this.hard_coded_programs];
			this.$store.commit("SET_CARTOGRAPHIE", {
				index: "hard_coded_programs" + this.suffix,
				value: [...this.hard_coded_programs],
			});
			this.$store.dispatch("save_study");
		},
		create_hard_coded_operation: function (prog_type = "prog") {
			const new_prog = JSON.parse(JSON.stringify(DEFAULT_PROGRAM));
			if (prog_type === "prog") {
				this.manage_map_card("add_operation");
			} else if (prog_type === "vente") {
				this.manage_map_card("add_vente");
				new_prog.type = "T1";
			} else if (prog_type === "annotation") {
				this.manage_map_card("add_annotation");
			}
			new_prog.location.lat = this.map_params.map.getCenter().lat;
			new_prog.location.lng = this.map_params.map.getCenter().lng;
			new_prog.popup_location.lat = this.map_params.map.getCenter().lat;
			new_prog.popup_location.lng = this.map_params.map.getCenter().lng;
			new_prog.prog_type = prog_type;
			new_prog.forme_urbaine = prog_type === "annotation" ? "" : new_prog.forme_urbaine;
			// this.hard_coded_programs.push(new_prog);
			const temp = [...this.hard_coded_programs, new_prog];

			if (prog_type !== "prog" || this.selected_markers.length + temp.filter((hc) => hc.prog_type === "prog").length <= 6) {
				this.hard_coded_programs = temp;
				this.$store.commit("SET_CARTOGRAPHIE", {
					index: "hard_coded_programs" + this.suffix,
					value: [...this.hard_coded_programs],
				});

				this.temp_prog = _.cloneDeep(new_prog);
				this.selected_hard = this.hard_coded_programs.length - 1;
			}
		},
		undo_map_update: function () {
			if (this.prev_map_params.length) {
				this.undoing_map_params = true;
				const last = this.prev_map_params.splice(-1)[0];
				this.map_params = { ...this.map_params, ...last };
				this.$nextTick(() => {
					this.undoing_map_params = false;
				});
			}
		},
		// fonctions pour le dessin de polylines
		addPoint2Polyline: function ($event) {
			this.selectedPolygone.push([$event.latlng.lat, $event.latlng.lng]);
			this.keyPolyline++;
		},
		updateMarkerFromSelectedPolygone: function ($event, key) {
			this.selectedPolygone[key] = [$event.target._latlng.lat, $event.target._latlng.lng];
			this.keyPolyline++;
		},
		removePointFromPolyline: function (key) {
			this.selectedPolygone.splice(key, 1);
			this.keyPolyline++;
		},
		saveSelectedPolygone: function () {
			let old = this.active_study.etudeData.cartographie[`custom_polygones${this.suffix}`];
			if (!!old == false) {
				old = {};
			} else {
				old = { ...old };
			}
			if (!!old[this.polygoneType] == false) {
				old[this.polygoneType] = [];
			}

			if (!this.selectedPolygoneId) {
				const value2Save = {
					"type": "Feature",
					"id": `${this.polygoneType}.${old[this.polygoneType].length}`,
					"geometry": {
						"type": "MultiPolygon",
						"coordinates": [[[...(this.selectedPolygone.map((coords) => [coords[1], coords[0]]))]]]
					},
					"geometry_name": "geom",
					"properties": {
						"id": `${this.polygoneType}.${old[this.polygoneType].length}`,
						"type": this.polygoneType
					}
				};
				value2Save.geometry.coordinates[0][0].push(value2Save.geometry.coordinates[0][0][0]);

				old[this.polygoneType] = [...old[this.polygoneType], value2Save];
			} else {
				const polygon = { ...old[this.polygoneType].find((poly) => poly.id === this.selectedPolygoneId) };
				polygon.geometry.coordinates[0][0] = [...(this.selectedPolygone.map((coords) => [coords[1], coords[0]]))];
				polygon.geometry.coordinates[0][0].push(polygon.geometry.coordinates[0][0][0]);
				old[this.polygoneType][old[this.polygoneType].findIndex((p) => p.id === this.selectedPolygoneId)] = polygon;
			}

			this.$store.commit("SET_CARTOGRAPHIE", {
				index: "custom_polygones" + this.suffix,
				value: { ...old },
			});
			this.manage_map_card("draw");
			this.keyPolyline++;
		},
		selectCustomPolygone: function ($event) {
			if (!this.layer_draw.visible) {
				this.polygoneType = $event.layer.feature.properties.type ? $event.layer.feature.properties.type : "ANRU";
				this.selectedPolygone = [...$event.layer.feature.geometry.coordinates[0][0]].map((coords) => [coords[1], coords[0]]);
				this.selectedPolygone.splice(-1, 1);
				this.selectedPolygoneId = $event.layer.feature.id;
				this.manage_map_card("draw");
			}
		},
		deleteSelectedCustomPolygon: function () {
			if (!this.selectedPolygoneId) {
				this.manage_map_card("draw");
				return;
			}
			const old = _.cloneDeep(this.active_study.etudeData.cartographie[`custom_polygones${this.suffix}`]);
			old[this.polygoneType].splice(old[this.polygoneType].findIndex((p) => p.id === this.selectedPolygoneId), 1);

			this.$store.commit("SET_CARTOGRAPHIE", {
				index: "custom_polygones" + this.suffix,
				value: { ...old },
			});
			this.manage_map_card("draw");
			this.keyPolyline++;
		},
		// fonctions pour l'ajout de POI
		addPoi2Map: function ($event) {
			if (this.typePoi.length === 0) return;
			this.currentPoi = {
				type: this.typePoi[0],
				coords: [$event.latlng.lat, $event.latlng.lng]
			};
		},
		updateMarkerCurrentPoi: function ($event) {
			this.currentPoi.coords = [$event.target._latlng.lat, $event.target._latlng.lng];
		},
		addCustomPoi: function () {
			const self = this;
			let old = this.active_study.etudeData.cartographie[`custom_poi${this.suffix}`];
			if (!!old == false) {
				old = [];
			} else {
				old = [...old];
			}
			this.$store.commit("SET_CARTOGRAPHIE", {
				index: `custom_poi${this.suffix}`,
				value: [...old, this.currentPoi]
			});
			this.manage_map_card("add_poi");
			// force refresh
			self.$store.dispatch("save_study");
			//reprint map
			this.reprint();
		},
		removeCustomPoi: function (latlng) {
			const lat = latlng[1];
			const lon = latlng[0];

			const self = this;
			let poi_list = this.active_study.etudeData.cartographie[`custom_poi${this.suffix}`];
			if (!!poi_list == false) {
				poi_list = [];
				return true;
			} else {
				poi_list = [...poi_list];
			}
			poi_list = poi_list.filter(p => p != null && p.coords[0] !== lat && p.coords[1] !== lon);
			this.$store.commit("SET_CARTOGRAPHIE", {
				index: `custom_poi${this.suffix}`,
				value: [...poi_list]
			});
			self.$store.dispatch("save_study");
			this.reprint();
		},
		resetSelectedPoi: function () {
			this.ticked = _.cloneDeep(DEFAULT_SELECTED_POI);
		}
	},
	mounted: function () {
		const selected_layer = this.active_study.etudeData.cartographie["selected_layer"];
		if ( selected_layer !== undefined ) {
			// le code dans cette condition a été rajouté à cause du renommage
			// dans l'outil cartographie de la couche ANRU en QPV. Pour ajouter
			// de nouveau la couche ANRU, il faudra enlever ce code et
			// s'assurer de la compatibilité avec les anciennes études
			if (selected_layer.includes("anru")){
				const renamedSelectedLayer = [...selected_layer].filter((value) => value != "anru");
				renamedSelectedLayer.push("qpv");
				this.$store.commit("SET_CARTOGRAPHIE", {
					index: "selected_layer" + this.suffix,
					value: renamedSelectedLayer,
				});
				this.load_layer(this.export_format.json_format, "qpv");
			}
			if (selected_layer.includes("anru_300")){
				const renamedSelectedLayer = [...selected_layer].filter((value) => value != "anru_300");
				renamedSelectedLayer.push("qpv_300");
				this.$store.commit("SET_CARTOGRAPHIE", {
					index: "selected_layer" + this.suffix,
					value: renamedSelectedLayer,
				});
				this.load_layer(this.export_format.json_format, "qpv_300");
			}
		}
		if(this.active_study.etudeData.cartographie["hidden_poi"] == undefined){
			this.$store.commit("SET_CARTOGRAPHIE", {
				index: "hidden_poi",
				value: [],
			});
		}
		this.$root.$on("updateRawPrograms", () => {
			this.rawProgrammes = _.cloneDeep(this.active_study.etudeData.cartographie.programmes);
			this.programmes = this.rawProgrammes;
		});
		// set programmes
		const self = this;
		if (typeof (this.active_study.etudeData.cartographie.programmes) !== "undefined") {
			self.rawProgrammes = _.cloneDeep(this.active_study.etudeData.cartographie.programmes);
			self.programmes = self.rawProgrammes;
		}

		if (typeof (this.active_study.etudeData[this.propertyAccessorView + "editLock"]) == "undefined") {
			this.$store.dispatch("edit_object", {
				obj: this.active_study.etudeData,
				field: this.propertyAccessorView + "editLock",
				value: false,
			});
			this.$store.dispatch("save_study");
		}
		this.toggleInteraction(this.active_study.etudeData[this.propertyAccessorView + "editLock"]);

		//const self = this;
		const get_leaves = function (array) {
			let temp = [];
			array.forEach((branch) => {
				if (!!branch.children === true) {
					temp = temp.concat(get_leaves(branch.children));
				} else {
					temp.push(branch.label);
				}
			});
			return temp;
		};
		this.leavesList = get_leaves(this.layer_opt.point_interet);

		function check_loading () {
			if (self.map_params.map && self.programmes) {
				self.adresses.adr_projet = self.active_study.projet.adresse.adresse;
				self.load_adresse("adr_projet");

				const s = self.suffix;

				if (self.active_study.etudeData.cartographie) {
					if (self.active_study.etudeData.cartographie["selected_layer" + s])
						self.selected_layer = self.active_study.etudeData.cartographie["selected_layer" + s];
					if (self.active_study.etudeData.cartographie["poi" + s])
						self.ticked = self.active_study.etudeData.cartographie["poi" + s];

					if (self.active_study.etudeData.cartographie[self.propertyAccessorView + "map_center"] && self.active_study.etudeData.cartographie[self.propertyAccessorView + "map_zoom"]) {
						self.map_params.map.setZoom(self.active_study.etudeData.cartographie[self.propertyAccessorView + "map_zoom"]);
						self.map_params.map.panTo(
							new L.LatLng(
								self.active_study.etudeData.cartographie[self.propertyAccessorView + "map_center"].lat,
								self.active_study.etudeData.cartographie[self.propertyAccessorView + "map_center"].lng
							)
						);
					}
					else if (self.active_study.etudeData.cartographie[self.propertyAccessorView + "bbox" + s]) {
						// replace fitBounds by setzoom + panto
						self.map_params.map.fitBounds(
							self.active_study.etudeData.cartographie[self.propertyAccessorView + "bbox" + s]
						);
					}

					if (self.active_study.etudeData.cartographie["popups" + s])
						self.popup_positions = [
							...self.active_study.etudeData.cartographie["popups" + s],
						];
					if (self.active_study.etudeData.cartographie["selected_markers" + s]) {
						self.selected_markers = [
							...self.active_study.etudeData.cartographie[
								"selected_markers" + s
							],
						];
					}
					if (self.active_study.etudeData.cartographie["filters" + s] && typeof (self.active_study.etudeData.cartographie.filters) !== "undefined") {
						self.selected_filter =
							self.active_study.etudeData.cartographie[
								"filters" + s
							];
					}
					if (self.active_study.etudeData.cartographie["hard_coded_programs" + s])
						self.hard_coded_programs = [
							...self.active_study.etudeData.cartographie[
								"hard_coded_programs" + s
							],
						];
					if (self.active_study.etudeData.cartographie["selected_mutations" + s])
						self.selected_mutations = [
							...self.active_study.etudeData.cartographie[
								"selected_mutations" + s
							],
						];
				} else {
					self.map_params.map.panTo(
						new L.LatLng(
							self.active_study.projet.position.location.lat,
							self.active_study.projet.position.location.lon
						)
					);
				}
				setTimeout(function () {
					self.lock = false;
				}, 1000);
			} else {
				setTimeout(function () {
					check_loading();
					//this.$forceUpdate();
					//reprint map
					self.reprint();
				}, 100);
			}
		}
		check_loading();
		//this.$forceUpdate();
		//reprint map
		this.reprint();
	},
};
</script>

<style lang="stylus" scoped>
@import '~leaflet/dist/leaflet.css';
@import '~leaflet.markercluster/dist/MarkerCluster.css';
@import '~leaflet.markercluster/dist/MarkerCluster.Default.css';

/*
z-index documentation :
.tooltip .tooltiptext : 1
.loading : 400
.features-options, .load-programmes  : 130
.box-edit-map : 135
.map-component .box-edit-line : 135
.vue2leaflet-map
	.poi-marker : 85
	.poi-marker-cluster : 90
	.project : 100
	.selected-card : 140
	.selected : 140
	.custom-marker-selected : 160
	.custom-marker-grp-selected : 160
	.custom-marker, .custom-marker-selected : 115
		&:hover : 150
	.custom-marker-grp, .custom-marker-grp-selected : 110
		&:hover : 150
	.custom-marker, .custom-marker-selected : 115
		&:hover : 150
*/

.wrapperIcone{
	display: grid;
	grid-template-rows: repeat(9,1fr);
	gap: 10px;
	grid-auto-flow: column;
}

.tooltip .tooltiptext {
  display: none;
  width: 200px;
  background-color: black;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;
  /* Position the tooltip */
  position: relative;
  left: 60px;
  bottom: 40px;
  z-index: 1 !important;
  opacity: 1;

  &.righter {
    left: 127px;
  }
}

.tooltip .tooltiptext.btnpoi {
  /* Position the tooltip */
  position: relative;
  left: 16px;
  top: 8px;
  background-color : red;
}

.tooltip .tooltiptext.btnpoi.disable {
  display : none;

}

.tooltip-group:hover .tooltiptext {
  display: block;
  opacity: 0.7;
}
.tooltip-group:hover{
	height: 30px;
	width: 30px;

}

.vue2leaflet-map {
  max-height: var(--height);

  >.leaflet-control-container {
    position: relative;
    height: var(--height);
    top: 0;
  }
}

.btn {
  margin-bottom: 5px;
  background: white;
}

.opt-input {
  overflow: auto;
  border-radius: 0;
  padding: 10px;
  margin-bottom: 5px;
  position: absolute;
  top: 0;
  width: 300px;
  left: 80px;
  max-height: 211px;
  &.slide-transition-select-poi {
    max-height: 480px;
  }
  &.allow-full-height {
    max-height: unset;
  }
}

.fil-input {
  overflow: auto;
  border-radius: 0;
  padding: 10px;
  margin-bottom: 5px;
  position: absolute;
  top: 0;
  width: 300px;
  left: 80px;
  max-height: 211px;
  pointer-events: all;

  &.allow-full-height {
    max-height: unset;
  }

  .q-card__section {
    padding: 4px;
  }
}

.loading {
  position: absolute;
  z-index: 400 !important;
  top: 45%;
  left: 50%;
}
.features-options, .load-programmes {
	position: static;
	display: flex;
	flex-direction: column;
	top: 56px;
	left: 10px;
	z-index: 130 !important;

  &.right {
    left: unset;
    right: 10px;
    width: auto;

    .tooltiptext {
      position: absolute;
      transform: translate(-100%, 0%);
      left: -10px;
      right: 0;
      top: 5px;
      height: fit-content;
    }
  }
}

.features-options {
	top: 10px;
  }

.btn-option {
  border-radius: 0;
}

.btn-filter {
  display: block;
  margin: 8px auto 0;
}
</style>

<style lang="stylus">

.box-edit-map {
    position: absolute;
    top: 0;
    left: -80px;
    transform: translateX(-150%);
    z-index: 135 !important;
}

.map-component .box-edit-line {
    position: absolute;
    top: 0;
    left: -80px;
    transform: translateX(-100%);
    width: 250px;
    background-color: #e7e0ec;
    box-shadow: 0 0 0 2px #ddd;
    z-index: 135 !important;

    &:after {
        content: '';
        position: absolute;
        left: -8px;
        top: 24px;
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 8px 0 8px 8px;
        border-color: transparent #ddd transparent transparent;
    }

    button {
        background: #f44336 !important;
        color: white;
        margin-top: 4px;

        .q-btn__content {
            padding-right: 8px;
        }
    }
}

.vue2leaflet-map {
    .project {
        z-index: 100 !important;
    }
	.poi-unselected {
		opacity: 0.5 !important;
	}
	.poi-hidden {
		opacity: 0 !important;
	}
	.poi-selected {
		opacity: 1 !important;
	}
    .poi-marker-cluster {
        z-index: 90 !important;
    }

    .poi-marker {
        z-index: 85 !important;
    }

    .leaflet-control-attribution {
        display: none !important;
        color: #123456;
    }

    > .leaflet-control-container {
        position: relative;
        min-height: var(--height);
        height: 100%;
        top: 0;
    }

    .selected-card {
        z-index: 140 !important;
        position: absolute;
        opacity: 0.95;
        width: auto !important;
        white-space: nowrap;

        p.num {
            margin-bottom: 16px;
            position: absolute;
            right: 8px;
            bottom: 8 px;
            background: #3e5d58;
            color: white;
            width: 24px !important;
            height: 24px !important;
            text-align: center;
            border-radius: 12px;
            font-size: 12px;

            span {
                position: relative;
                top: 4px;
            }
        }

        &--mutation {
            p.num {
                bottom: auto;
                top: -3px;
                right: -3px;
            }
        }

        .q-card {
            &.transparent {
                box-shadow: none;

                .q-card__section--vert {
                    background: none;
                }
            }
        }

        .selected {
            z-index: 140 !important;

            .name {
                font-weight: bold;
                font-size: 12px;
            }

            p {
                font-size: 10px;
            }

            .q-card__section--vert {
                padding: 4px !important;
                background-color: #e0ebe9;
            }

            .q-card__section--rouge {
                padding: 4px !important;
                background-color: #edd5d5;
            }
        }
    }

    .custom-marker, .custom-marker-selected {
        background: #ff4081;
        opacity: 0.9;
        width: 24px !important;
        height: 24px !important;
        border-radius: 12px;
        z-index: 115 !important;

        .hovered, .selected {
            display: none;
            position: absolute;
            top: 24px;
            left: -63px !important;
            width: 300px;

            .name {
                font-weight: bold;
                font-size: 12px;
            }

            p {
                font-size: 10px;
            }
        }

        &:hover {
            z-index: 150 !important;

            .hovered {
                display: block;
            }
        }
    }

    .custom-marker.individuel {
        background: #f8bbd0;
    }

    .custom-marker.notDisplay {
        background-color: black;
        opacity: 0.08 !important;
        pointer-events: none;
    }

    .custom-marker-grp.notDisplay {
        background-color: rgba(0, 0, 0, 0.05);
        pointer-events: none;
        border: 3px solid rgba(0, 0, 0, 0.1);
    }
}

.legend-icon {
    border-radius: 50% !important;
}

.custom-marker, .custom-marker-selected {
    background: #ff4081;
    opacity: 0.9;
    width: 24px !important;
    height: 24px !important;
    border-radius: 12px;
    z-index: 115 !important;

    .hovered, .selected {
        display: none;
        position: absolute;
        top: 24px;
        left: -63px !important;
        width: 300px;

        .name {
            font-weight: bold;
            font-size: 12px;
        }

        p {
            font-size: 10px;
        }
    }

    &:hover {
        z-index: 150 !important;

        .hovered {
            display: block;
        }
    }
}

.custom-marker.individuel {
    background: #f8bbd0;
}

.hide-marker .custom-marker {
    display: none !important;
}

.hide-marker .custom-marker-grp {
    display: none !important;
}

.icon-total-childs {
    position: absolute;
    top: -5px;
    right: -5px;
    background: #0FA8BD;
    color: #FFFFFF;
    width: 15px;
    height: 15px;
    border-radius: 15px;
    font-size: 11px;
    text-align: center;
}

.icon-close-custom-poi {
    visibility: hidden;
    position: absolute;
    top: -5px;
    right: -5px;
    background: red;
    color: #FFFFFF;
    width: 15px;
    height: 15px;
    border-radius: 15px;
    font-size: 11px;
    text-align: center;
}

.custom-poi-parent:hover .icon-close-custom-poi {
    visibility: visible;
}

.icon-img-custom-poi {
	width: 30px;
    height: 30px;
}

.edit-map .icon-img-custom-poi {
    border-radius: 50%;
    border-color: black;
    border-width: 2px;
    border-style: solid;
}

.current-polygone-marker {
    width: 20px;
    height: 20px;
    background: #ff8f00;
    border: 2px solid #FFFFFF;
    border-radius: 10px;
}

.icon-cluster {
    width: 30px;
    height: 30px;
}

.typo-input {
	display:inline-block !important; //important to override quasar default style
}

#validate-hard-coded-button{
	background-color:green !important;
}

.hard-coded-button-block{
	display:flex;
	justify-content: space-evenly;
	margin:3% 0;
}
</style>